import { InjectionToken } from '@angular/core';

import { MaintenanceRoutes } from '../models';

/**
 * Die Adressen der Anwendung, die der Wartungsmodus kennen muss.
 *
 * Bereitgestellt wird der Wert von `provideMaintenanceFeature()`; einen Standardwert gibt es bewusst nicht,
 * damit eine fehlende Angabe sofort auffällt und nicht als falsche Adresse weiterläuft.
 */
export const MAINTENANCE_ROUTES = new InjectionToken<MaintenanceRoutes>('MaintenanceRoutes');
